import { graphql } from 'src/gql';

export const ClientPortalNetWorthHistoryQuery = graphql(`
  query ClientPortalNetWorthHistory($id: ID!, $householdId: ID) {
    portfolio(userId: $id, householdId: $householdId) {
      id
      portfolioItemGroups {
        name
        historicalValues {
          date
          value {
            amount
          }
        }
      }
    }
  }
`);
